import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { withRouter } from '../../common/withRouter';
import { MotifTabNavigation, MotifTabControl } from '@ey-xd/motif-react';
import { Link } from 'react-router';

import * as bulkProcessManagementActions from '../../actions/bulkProcessManagementActions';
import * as newPeriodActions from '../../actions/newPeriodActions';
import * as reitActions from '../../actions/reitActions';
import * as clientActions from '../../actions/clientActions';
import * as Constants from '../../constants/other';
import * as actions from '../../actions/actionTypes';
import * as authActions from '../../actions/authActions';
import ScopedServicesModal from '../../components/reits/ScopedServicesModal';
import BulkProcessUpdateServiceAlertModal from '../../components/bulkProcessManagement/BulkProcessUpdateServiceAlertModal';
import ServicesScopeHeader from '../../components/bulkPeriodManagement/ServicesScopeHeader';
import BulkPeriodServicesScopeTable from '../../components/bulkPeriodManagement/BulkPeriodServicesScopeTable';
import * as periodActions from '../../actions/periodActions';
import ReportPeriodComparator from '../../components/shared/customComparators/ReportPeriodComparator';

/**
 * BulkPeriodManagementServicesScopeContainer component
 * @extends {React.Component}
 */
export class BulkPeriodManagementServicesScopeContainer
  extends React.Component
{
  /**
   * Creates a new BulkPeriodManagementServicesScopeContainer
   * @constructor
   * @param {Object} props The component properties
   * @param {Object} context The component context
   */
  constructor(props, context) {
    super(props, context);

    this.handleReportPeriodSelection =
      this.handleReportPeriodSelection.bind(this);
    this.handleGridChanges = this.handleGridChanges.bind(this);
    this.setGridColumnState = this.setGridColumnState.bind(this);
    this.handleGridColumnStateChange =
      this.handleGridColumnStateChange.bind(this);
    this.toggleServiceScopeModal = this.toggleServiceScopeModal.bind(this);
    this.handleServiceScopeSaveAction =
      this.handleServiceScopeSaveAction.bind(this);
    this.handleServiceScopeCancelAction =
      this.handleServiceScopeCancelAction.bind(this);
    this.handleServiceSelected = this.handleServiceSelected.bind(this);
    this.toggleShowUpdateServiceScopeInfo =
      this.toggleShowUpdateServiceScopeInfo.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.fetchReportPeriodsByClientId =
      this.fetchReportPeriodsByClientId.bind(this);

    this.state = {
      calendarYears: [],
      selectedCalanderYear: null,
      selectedQuarter: null,
      bulkProcessManagementData: [],
      gridCurrentState: [],
      gridColumnState: [],
      showServiceScopeModal: false,
      selectedServices: Constants.defaultSelectedServiceScope,
      bulkProcessActionId: 1, // For service scope update
      diagnosticMessage: '',
      showUpdateServiceScopeInfo: false,
      isAudit: false,
      defaultReportPeriod: null,
      reportPeriods: [],
    };
  }

  /**
   * Invoked immediately after mounting occurs
   * @returns {undefined}
   */
  componentDidMount() {
    // Get available REITs in a report period then set the calendar year and current quarter
    this.fetchReportPeriodsByClientId();
    this.setGridColumnState();
    if (this.props.reitActions) {
      this.props.reitActions.fetchReitLookupTypes();
    }
    this.getClientData();
  }

  /**
   * Invoked when a new props is received
   * @returns {undefined}
   */
  componentDidUpdate(prevProps) {
    if (
      this.props.bulkProcessManagementData &&
      this.props.bulkProcessManagementData !==
        prevProps.bulkProcessManagementData
    ) {
      this.setState({
        bulkProcessManagementData: this.props.bulkProcessManagementData,
      });
    }
  }

  /**
   * Invoked immediately before unmounting occurs
   * @returns {undefined}
   */
  componentWillUnmount() {
    // On unmount, clear the state to conserve memory
    this.setState({ bulkProcessManagementData: [] });

    // Clearing the redux state for bulk process management data
    this.props.bulkProcessManagementActions.fetchBulkProcessManagementData();
  }

  getClientData() {
    this.props.clientActions.loadClient(this.props.clientId).then(() => {
      this.setState({ isAudit: this.props.client.isAudit });
      if (this.props.client.isAudit) {
        this.props.router.navigate(
          `/client/${this.props.clientId}/bulkPeriodManagement`
        );
      }
    });
  }

  handleReportPeriodSelection(reportPeriod) {
    if (!reportPeriod || typeof reportPeriod !== 'string') {
      return;
    }

    // Extract quarter and year from report period string (format: "Q1 2023")
    const parts = reportPeriod.split(' ');
    const quarter = parts[0]; // e.g., "Q1"
    const year = parseInt(parts[1]); // e.g., 2023

    this.setState(
      {
        selectedQuarter: quarter,
        selectedCalanderYear: year,
        defaultReportPeriod: reportPeriod,
      },
      this.getBulkProcessManagementData
    );
  }

  getBulkProcessManagementData() {
    this.props.bulkProcessManagementActions
      .fetchBulkProcessManagementData(
        this.props.clientId,
        this.state.selectedCalanderYear, // Use the extracted year
        this.state.selectedQuarter // Use the extracted quarter
      )
      .then(() => {
        this.setState({
          bulkProcessManagementData: this.props.bulkProcessManagementData,
        });
      });
  }

  /**
   * Set AG-Grid column state
   * @returns {undefined}
   */
  setGridColumnState() {
    var columnState = localStorage.getItem(
      'REITSuiteBulkProcessManagementColumnState'
    );
    if (columnState) {
      this.setState({ gridColumnState: JSON.parse(columnState) });
    } else {
      this.setState({ gridColumnState: [{ colId: '-1' }] });
    }
  }

  /**
   * Handle Grid column state change
   * @returns {undefined}
   */
  handleGridColumnStateChange(columnState) {
    this.setState({ gridColumnState: columnState });
  }

  toggleShowUpdateServiceScopeInfo() {
    this.setState({
      showUpdateServiceScopeInfo: !this.state.showUpdateServiceScopeInfo,
    });
  }

  handleServiceScopeSaveAction() {
    this.initiateBulkProcess();
  }

  handleServiceScopeCancelAction() {
    this.setState({ selectedServices: Constants.defaultSelectedServiceScope });
    this.toggleServiceScopeModal();
  }

  toggleServiceScopeModal() {
    const currentUserIsEngagementUser = authActions.isUser(
      this.props.currentUserAuthorizations,
      this.props.clientId
    );

    if (
      currentUserIsEngagementUser &&
      this.hasCompleteOrClosedToReportingReits()
    ) {
      this.toggleShowUpdateServiceScopeInfo();
      return;
    }

    // If no REITs are selected, disable the button
    if (
      !this.state.gridCurrentState ||
      !this.state.gridCurrentState.some((r) => r.reitSelection)
    ) {
      return;
    }

    this.setState({ selectedServices: Constants.defaultSelectedServiceScope });
    this.setState({
      showServiceScopeModal: !this.state.showServiceScopeModal,
    });
  }

  handleServiceSelected(service, isSelected) {
    if (isSelected) {
      const selectedServicesSet = new Set([
        ...this.state.selectedServices,
        service,
      ]);
      this.setState({ selectedServices: [...selectedServicesSet] });
    } else {
      const selectedServices = this.state.selectedServices.filter(
        (s) => s !== service
      );
      this.setState({ selectedServices });
    }
  }

  handleGridChanges(gridRowData) {
    let rowData = [];
    rowData =
      gridRowData &&
      gridRowData.length &&
      gridRowData.map((x) => {
        return {
          reitID: x.reitid,
          isReitAvailableForSelection: x.isReitAvailableForSelection,
          reitSelection: x.isReitAvailableForSelection
            ? x.reitSelection
            : false,
          assetTesting: x.assetTesting,
          incomeTesting: x.incomeTesting,
          distributionTesting: x.distributionTesting,
          psq: x.psq,
          arqc: x.arqc,
          leaseReview: x.leaseReview,
          signOffStatus: x.signOffStatus,
        };
      });

    this.setState({
      gridCurrentState: rowData,
    });
  }

  initiateBulkProcess() {
    const request = {
      clientId: this.props.clientId,
      calendarYear: this.state.selectedCalanderYear,
      quarterDescription: this.state.selectedQuarter,
      reitIds: this.getSelectedReits(),
      bulkProcessActionId: this.state.bulkProcessActionId,
      diagnosticMessage: this.state.diagnosticMessage,
      bulkProcessRequestJSON: this.getBulkProcessRequestJSON(),
    };

    const currentGridState = [...this.state.gridCurrentState];
    const currentBulkProcessManagementDataState = [
      ...this.state.bulkProcessManagementData,
    ];

    this.updateCheckboxsState(request.reitIds);

    this.props.bulkProcessManagementActions
      .initiateBulkProcess(request)
      .then((isErrored) => {
        if (isErrored) {
          this.setState({
            currentGridState: currentGridState,
            bulkProcessManagementData: currentBulkProcessManagementDataState,
          });
        }
      })
      .catch((isErrored) => {
        if (isErrored) {
          this.setState({
            currentGridState: currentGridState,
            bulkProcessManagementData: currentBulkProcessManagementDataState,
          });
        }
      });

    this.resetModalsToggleState();
  }

  updateCheckboxsState(reitsToBeUpdated) {
    const rowData = this.state.gridCurrentState.map((row) => {
      if (reitsToBeUpdated.find((r) => r === row.reitID)) {
        return {
          ...row,
          isReitAvailableForSelection: false,
          reitSelection: false,
        };
      } else {
        return row;
      }
    });

    const updatedBulkProcessManagementData =
      this.state.bulkProcessManagementData.map((data) => {
        if (reitsToBeUpdated.find((r) => r === data.reitid)) {
          return {
            ...data,
            isReitAvailableForSelection: false,
            reitSelection: false,
          };
        } else {
          return data;
        }
      });

    this.props.bulkProcessManagementActions.dispatchBulkProcessData(
      updatedBulkProcessManagementData,
      actions.LOAD_BULK_PROCESS_MANAGEMENT_DATA_REFRESH
    );
    this.setState({
      gridCurrentState: rowData,
    });
  }

  resetModalsToggleState() {
    this.setState({ showServiceScopeModal: false });
  }

  getSelectedReits() {
    return this.state.gridCurrentState
      .filter((r) => r.reitSelection)
      .map((r) => r.reitID);
  }

  hasCompleteOrClosedToReportingReits() {
    return this.state.gridCurrentState.some(
      (r) =>
        (r.signOffStatus === 'Complete' ||
          r.signOffStatus === 'Reporting Closed' ||
          r.signOffStatus === 'Testing Closed') &&
        r.reitSelection
    );
  }

  getBulkProcessRequestJSON() {
    return {
      services:
        this.state.bulkProcessActionId === 1 &&
        !this.state.selectedServices.length
          ? Constants.emptySelectedServiceScope
          : this.state.selectedServices,
      requestedSignOffStatus: null,
    };
  }

  setActiveTab(currentIndex) {
    this.setState({ tabBar1: currentIndex });
  }

  // Set current tab index
  handleTabClick(index) {
    this.setActiveTab(index);
  }

  fetchReportPeriodsByClientId() {
    this.props.periodActions
      .fetchReportPeriodsByClientId(this.props.clientId)
      .then((periods) => {
        if (!periods || periods.length === 0) {
          return;
        }

        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();

        const uniqueDescriptions = [
          ...new Set(
            periods
              .filter((p) => p.reportPeriodDescription)
              .map((p) => p.reportPeriodDescription)
          ),
        ];

        const sortedPeriods = uniqueDescriptions.sort(ReportPeriodComparator);

        const currentQuarter = `Q${Math.ceil((currentDate.getMonth() + 1) / 3)} ${currentYear}`;
        const defaultReportPeriod =
          sortedPeriods.find((p) => p === currentQuarter) ||
          sortedPeriods[0] ||
          null;

        this.setState(
          {
            reportPeriods: sortedPeriods,
          },
          () => this.handleReportPeriodSelection(defaultReportPeriod)
        );
      });
  }

  /**
   * Render a React element
   * @returns {Object} A reference to the component
   */
  render() {
    const { bulkProcessManagementData } = this.state;
    const { defaultReportPeriod } = this.state;
    const noData = !bulkProcessManagementData?.length;
    const noReit = !defaultReportPeriod?.length;

    return (
      <>
        <h2 data-testid="pghdrBulkPeriodManagement">Bulk Period Management</h2>
        <MotifTabNavigation variant="default">
          <Link
            to={`/client/${this.props.clientId}/bulkPeriodManagement`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              data-testid="tbNewPeriod"
              onClick={() => this.handleTabClick(1)}
            >
              New Period
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/bulkPeriodManagement/servicesScope`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              data-testid="tbServicesScope"
              className="motif-active"
              onClick={() => this.handleTabClick(2)}
            >
              Services Scope
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/bulkPeriodManagement/ownership`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              data-testid="tbOwnership"
              onClick={() => this.handleTabClick(3)}
            >
              Ownership %
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/bulkPeriodManagement/tenantServicesAmenities`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              data-testid="tbTenantServices"
              onClick={() => this.handleTabClick(4)}
            >
              Tenant Services / Amenities
            </MotifTabControl>
          </Link>
          <Link
            to={`/client/${this.props.clientId}/bulkPeriodManagement/signOff`}
            tabIndex="-1"
          >
            <MotifTabControl
              role="tab"
              data-testid="tbSignOff"
              onClick={() => this.handleTabClick(5)}
            >
              Sign Off
            </MotifTabControl>
          </Link>
        </MotifTabNavigation>

        {noReit ? (
          <div className="mt-3">No REITs found for the selected client.</div>
        ) : (
          <ServicesScopeHeader
            handleReportPeriodSelection={this.handleReportPeriodSelection}
            gridCurrentState={this.state.gridCurrentState}
            toggleServiceScopeModal={this.toggleServiceScopeModal}
            isAuditOnlyClient={this.props.client.isAudit}
            defaultReportPeriod={this.state.defaultReportPeriod}
            reportPeriods={this.state.reportPeriods}
          />
        )}

        {noData && !noReit ? (
          <div className="mt-3">
            No REITs found for the selected report period.
          </div>
        ) : (
          <>
            <BulkPeriodServicesScopeTable
              bulkProcessManagementData={this.state.bulkProcessManagementData}
              handleGridChanges={this.handleGridChanges}
              gridColumnState={this.state.gridColumnState}
              handleGridColumnStateChange={this.handleGridColumnStateChange}
            />

            <ScopedServicesModal
              services={this.state.selectedServices}
              showServicesModal={this.state.showServiceScopeModal}
              handleSave={this.handleServiceScopeSaveAction}
              handleCancel={this.handleServiceScopeCancelAction}
              lookupTypes={this.props.lookupTypes}
              handleServiceSelected={this.handleServiceSelected}
              isBulkProcess={true}
              periodId={0} // Not needed for bulk process
            />
            <BulkProcessUpdateServiceAlertModal
              showUpdateServiceScopeInfo={this.state.showUpdateServiceScopeInfo}
              toggleShowUpdateServiceScopeInfo={
                this.toggleShowUpdateServiceScopeInfo
              }
            />
          </>
        )}
      </>
    );
  }
}

BulkPeriodManagementServicesScopeContainer.propTypes = {
  clientId: PropTypes.number,
  bulkProcessManagementData: PropTypes.array,
  reitActions: PropTypes.object,
  currentUserAuthorizations: PropTypes.array,
  client: PropTypes.object,
  router: PropTypes.object,
};

/**
 * Maps items from state to properties of the component
 * @param {Object} state The state
 * @returns {Object} An object containing properties that the component can access
 */
function mapStateToProps(state, ownProps) {
  return {
    clientId: Number.parseInt(ownProps.router.params.clientId),
    bulkProcessManagementData: state.bulkProcessManagementData,
    lookupTypes: state.lookupTypes,
    currentUserAuthorizations: state.currentUserAuthorizations,
    client: state.client,
    isAudit: state.client.isAudit,
  };
}

/**
 * Binds actions to the dispatcher
 * @param {Object} dispatch The action dispatcher
 * @returns {Object} An object containing properties that the component can access
 */
function mapDispatchToProps(dispatch) {
  return {
    bulkProcessManagementActions: bindActionCreators(
      bulkProcessManagementActions,
      dispatch
    ),
    newPeriodActions: bindActionCreators(newPeriodActions, dispatch),
    reitActions: bindActionCreators(reitActions, dispatch),
    clientActions: bindActionCreators(clientActions, dispatch),
    periodActions: bindActionCreators(periodActions, dispatch),
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    reduxForm({
      form: 'bulkPeriodServicesScopeForm',
      enableReinitialize: true,
    })(BulkPeriodManagementServicesScopeContainer)
  )
);
